/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbMetierGridDto
 */
export interface FcbMetierGridDto {
    /**
     * 
     * @type {number}
     * @memberof FcbMetierGridDto
     */
    idmetier?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbMetierGridDto
     */
    idstade?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbMetierGridDto
     */
    stade?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbMetierGridDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbMetierGridDto
     */
    masculin?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbMetierGridDto
     */
    integre?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbMetierGridDto
     */
    actif?: boolean | null;
}

/**
 * Check if a given object implements the FcbMetierGridDto interface.
 */
export function instanceOfFcbMetierGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbMetierGridDtoFromJSON(json: any): FcbMetierGridDto {
    return FcbMetierGridDtoFromJSONTyped(json, false);
}

export function FcbMetierGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbMetierGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idmetier': !exists(json, 'idmetier') ? undefined : json['idmetier'],
        'idstade': !exists(json, 'idstade') ? undefined : json['idstade'],
        'stade': !exists(json, 'stade') ? undefined : json['stade'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'masculin': !exists(json, 'masculin') ? undefined : json['masculin'],
        'integre': !exists(json, 'integre') ? undefined : json['integre'],
        'actif': !exists(json, 'actif') ? undefined : json['actif'],
    };
}

export function FcbMetierGridDtoToJSON(value?: FcbMetierGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idmetier': value.idmetier,
        'idstade': value.idstade,
        'stade': value.stade,
        'code': value.code,
        'masculin': value.masculin,
        'integre': value.integre,
        'actif': value.actif,
    };
}

